import "./App.css";

import DashAroundImage from "./images/DashAroundShowCase.png";

import LandingPage from "./components/LandingPage";
import ShowCase from "./components/ShowCase";

function App() {
  return (
    <main className="App">
      <LandingPage />
      <ShowCase
        title="Dash Around"
        imgSrc={DashAroundImage}
        description={`
        Embark on an endless journey through the vibrant pixelated world of "Dash Around"! 
        Take on the role of a charming ninja, dashing swiftly through a landscape filled with obstacles and challenges at every turn. 
        In this thrilling infinite runner, your goal is simple: survive for as long as you can as you dash, duck, and leap over hurdles that come your way. 
        With each passing moment, the pace quickens, testing your reflexes and agility to the limit.
        `}
      />
    </main>
  );
}

export default App;
